<ion-card class="m-0">
  <ion-card-header>
    <ion-card-title>{{ title }}</ion-card-title>
    <!-- <ion-card-subtitle>{{ message }}</ion-card-subtitle> -->
  </ion-card-header>
  <ion-card-content>
    <div style="font-size: 22px" class="mb-3">{{ message }}</div>
    <div class="note">
      <ion-textarea
        style="--width: 100%"
        [(ngModel)]="note"
        placeholder="Коментар"
      ></ion-textarea>
    </div>
  </ion-card-content>
  <div class="flex-container ion-padding">
    <ion-button fill="outline" color="dark" (click)="buttonClick('cancel')">
      Відмінити
    </ion-button>
    <span class="flex-spacer"></span>
    <ion-button fill="solid" [color]="color" (click)="buttonClick('confirmed')">
      {{ label }}
    </ion-button>
  </div>
</ion-card>
